import { Controller } from '@hotwired/stimulus';

// Namespaced so one key can't collide with whatever else the app puts in localStorage.
const PREFIX = 'collapsible:';
const OPEN = 'open';
const CLOSED = 'closed';

// Remembers whether a <details> was left open, so a save doesn't dump the user back at the
// top of a form they had already arranged (#185 point 14). The key is per profile and per
// section - see SectionCardComponent - because "I keep my gear section open" is about that
// one profile's gear, not about every card in the app.
//
// Everything else about folding is the element's own: this controller has no opinion on what
// the initial state should be and never toggles anything on its own. A section the server
// forced open because it holds a validation error is rendered without this controller at all,
// so a remembered "closed" can't hide an error message, and the forced state can't be saved
// as if it were a preference.
//
// Progressive enhancement: with the bundle blocked, <details> still folds - only the memory
// of it is lost.
export default class extends Controller {
  static values = { key: String };

  connect() {
    const stored = this.read();
    if (stored) this.element.open = stored === OPEN;
  }

  save() {
    this.write(this.element.open ? OPEN : CLOSED);
  }

  // Storage throws rather than degrading in Safari's private mode and wherever the user has
  // turned it off, and a card that won't unfold is a worse bug than one that forgets.
  read() {
    try {
      return localStorage.getItem(PREFIX + this.keyValue);
    } catch {
      return null;
    }
  }

  write(value) {
    try {
      localStorage.setItem(PREFIX + this.keyValue, value);
    } catch {
      // Nothing to do about it, and nothing the user needs to hear.
    }
  }
}
